<template>
  <div class="w-100 h-100">
    <dv-border-box-7>
      <el-carousel
        indicator-position="none"
        class="w-100"
        :height="screenheight"
        :interval="5000"
      >
        <el-carousel-item v-for="item in dataSet" :key="item['title']">
          <div class="w-100 h-45">
            <div style="width: 50%; float: left">
              <dv-decoration-3
                style="
                  width: 50%;
                  height: 50px;
                  opacity: 0.2;
                  text-align: center;
                  position: absolute;
                  left: 0;
                "
              />
              <div class="line_title">节拍时间(s)</div>
            </div>
            <div style="width: 50%; float: right">
              <dv-decoration-3
                style="
                  width: 50%;
                  height: 50px;
                  opacity: 0.2;
                  text-align: center;
                  position: absolute;
                  right: 0;
                "
              />
              <div class="line_title">班次人数</div>
            </div>

            <div style="height:35%"></div>

            <div class="circlelist">
              <ul class="clearfix">
                <li>
                  <div class="circle">{{ item["taskTime"] }}</div>
                </li>
                <li>
                  <div class="circle">
                    {{ item["shouldAttend"] }}
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="w-100 h-50">
            <div
              class="line_title"
              style="
                float: left;
                width: 75%;
                margin-bottom: 1%;
                overflow: hidden;
              "
            >
              {{ item["title"] }}产量追踪
            </div>
            <div
              v-if="item['planned'] > item['actual']"
              style="
                float: left;
                text-align: center;
                font-size: 14px;
                width: 25%;
              "
            >
              <div class="delay-title" style="float: right;">
                落后计划<br />
                {{ item["planned"] - item["actual"] }} 件
              </div>
            </div>
            <div class="w-80 h-100" style="float: left">
              <dv-charts :option="setOption(item['record'])" />
            </div>
            <div class="w-20 h-40" style="float: right; padding-top: 10px">
              <dv-border-box-12
                ><div
                  style="
                    padding-top: 30%;
                    color: #00a67c;
                    text-align: center;
                    font-weight: bold;
                    font-size: 16px;
                  "
                >
                  实际
                </div>
                <div
                  style="
                    padding-top: 2%;
                    font-weight: bold;
                    font-size: 24px;
                    text-align: center;
                  "
                >
                  {{ item["actual"] }}
                </div></dv-border-box-12
              >
            </div>

            <div class="w-20 h-40" style="float: right; padding-top: 5px">
              <dv-border-box-12>
                <div
                  style="
                    padding-top: 30%;
                    color: #3486da;
                    text-align: center;
                    font-weight: bold;
                    font-size: 16px;
                  "
                >
                  计划
                </div>
                <div
                  style="
                    padding-top: 2%;
                    font-weight: bold;
                    font-size: 24px;
                    text-align: center;
                  "
                >
                  {{ item["planned"] }}
                </div></dv-border-box-12
              >
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </dv-border-box-7>
  </div>
</template>

<script>
export default {
  name: "oee-productline-weekly",
  props: {
    topData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    beans: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      screenheight: document.documentElement.clientHeight / 1.7 + "px",
      taskTime: 0,
      shouldAttend: 0,
      planned: 0,
      actual: 0,
      dataBean: this.beans,
      option: {},
      dataSet: [],
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.dataBean = val;
        this.fmDataSet();
      },
      deep: true,
    },
    topData: {
      handler: function (val, oldVal) {
        this.formatData(val);
      },
      deep: true,
    },
  },
  mounted() {
    // this.lineEchart();
  },
  created() {
    window.onresize = () => {
      return () => {
        this.screenheight = (document.documentElement.clientHeight/1.70) + "px";
      };
    };
  },
  methods: {
    formatData(bean) {
      this.taskTime = bean["taskTime"] || 0;
      this.shouldAttend = bean["shouldAttend"] || 0;
    },

    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },

    fmDataSet() {
      //数据渲染
      var data = this.dataBean;
      this.dataSet = [];
      for (var key in data) {
        var records = data[key];
        var taskTime = 0;
        var shouldAttend = 0;
        var map = {};
        map["title"] = key;
        map["record"] = data[key];
        var plan = 0;
        var actual = 0;
        records.forEach((val) => {
          plan += val.forecast;
          actual += val.actual;
          taskTime = val.taskTime;
          shouldAttend = val.shouldAttend;
        });
        map["planned"] = plan;
        map["actual"] = actual;
        map["shouldAttend"] = shouldAttend;
        map["taskTime"] = taskTime;
        this.dataSet.push(map);
      }
    },

    setOption(data) {
      console.log(this.dataSet);

      var xAxis = [];
      var linePlan = [];
      var lineActual = [];
      var plan = 0;
      var actual = 0;
      data.forEach((val) => {
        xAxis.push(val["timeBucket"].split("-")[1]);
        plan += val.forecast;
        actual += val.actual;
        linePlan.push(plan);
        lineActual.push(actual);
      });

      var option = {};
      //未有开班信息
      if (linePlan.length < 1) {
        option = {
          title: {
            text: "今日还未录入",
            x: "center",
            y: "center",
            offset: [10, 5],
            style: {
              fontSize: 18,
              fill: "#FFFFFF",
              fontWeight: "bold",
              textBaseline: "bottom",
            },
          },
        };
        return option;
      }

      option = {
        grid: {
          right: "0",
          left: "15%",
          top: "15%",
          bottom: "15%",
        },
        xAxis: {
          data: xAxis,
          axisLabel: {
            style: {
              fill: "#fff", // 坐标值得具体的颜色
              fontSize: 10,
            }
          },
          axisTick: {
            style: {
              stroke: "#fff", // 坐标值得具体的颜色
            }
          },
        },
        yAxis: [
          {
            name: "目标",
            data: "value",
            min: 0,
            nameTextStyle: {
              fill: "#ffffff",
              fontSize: 12,
            },
            axisLabel: {
              formatter: "{value} 件",
              style: {
                fill: "#fff", // 坐标值得具体的颜色
                fontSize: 13,
              },
            },
            splitLine: {
              style: {
                lineDash: [3, 3],
              },
            },
          },
        ],
        legend: {
          show: true,
          top: "5%",
          right: "0%",
          data: ["计划", "实际"],
          textStyle: {
            fill: "#FFFFFF",
          },
        },
        series: [
          {
            name: "计划",
            data: linePlan,
            type: "line",
            barMaxWidth: 50,
            lineStyle: {
              lineWidth: 1,
              stroke: "#0072D7",
            },

            lineArea: {
              show: true,
              gradient: ["#0072D7", "rgba(251, 114, 147, 0)"],
            },
          },
          {
            name: "实际",
            data: lineActual,
            type: "line",
            lineStyle: {
              lineWidth: 1,
              stroke: "#00A266",
            },
            lineArea: {
              show: true,
              gradient: ["rgba(103, 224, 227, .6)", "rgba(103, 224, 227, .1)"],
            },
          },
        ],
      };

      return option;
    },

    createOptions(data) {
      var xAxis = [];
      var lineKpi = [];
      var lineData = [];

      var plan = 0;
      var actual = 0;
      var workingHours = 0; // 已累计工作时长
      data.forEach((val) => {
        xAxis.push(val["timeBucket"].split("-")[1]);
        plan += val.forecast;
        actual += val.actual;
        workingHours += val.workingHours;
        lineData.push(plan);
        lineKpi.push(actual);
      });

      //数据展示,实际，合计
      if (data.length > 0) {
        this.planned = plan;
        this.actual = actual;
      }

      var option = {};
      //未有开班信息
      if (lineData.length < 1) {
        option = {
          title: {
            text: "今日还未录入",
            x: "center",
            y: "center",
            offset: [10, 5],
            style: {
              fontSize: 18,
              fill: "#FFFFFF",
              fontWeight: "bold",
              textBaseline: "bottom",
            },
          },
        };
        return;
      }

      option = {
        grid: {
          right: "0",
          left: "10%",
          top: "10%",
        },
        xAxis: {
          data: xAxis,
          axisLabel: {
            textStyle: {
              fill: "#fff", // 坐标值得具体的颜色
              fontSize: 10,
            },
          },
          axisTick: {
            style: {
              stroke: "#fff", // 坐标值得具体的颜色
            },
          },
        },
        yAxis: [
          {
            name: "目标",
            data: "value",
            min: 0,
            nameTextStyle: {
              fill: "#ffffff",
              fontSize: 12,
            },
            axisLabel: {
              formatter: "{value} 件",
              style: {
                fill: "#fff", // 坐标值得具体的颜色
              },
            },
            splitLine: {
              style: {
                lineDash: [3, 3],
              },
            },
          },
        ],
        legend: {
          show: true,
          top: "10%",
          right: "0%",
          data: ["计划", "实际"],
          textStyle: {
            fill: "#FFFFFF",
          },
        },
        series: [
          {
            name: "计划",
            data: lineData,
            type: "line",
            barMaxWidth: 50,
            lineStyle: {
              lineWidth: 1,
              stroke: "#0072D7",
            },

            lineArea: {
              show: true,
              gradient: ["#0072D7", "rgba(251, 114, 147, 0)"],
            },
          },
          {
            name: "实际",
            data: lineKpi,
            type: "line",
            lineStyle: {
              lineWidth: 1,
              stroke: "#00A266",
            },
            lineArea: {
              show: true,
              gradient: ["rgba(103, 224, 227, .6)", "rgba(103, 224, 227, .1)"],
            },
          },
        ],
      };

      return option;
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>

<style scoped src='../productLine/board.css'>
</style>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/oee/component/oee-productline-weekly.vue